<template>
  <header>
    <!-- header-area start -->
    <div class="header-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-6">
                    <!-- top-search-area start -->
                    <div class="top-search-area">
                        <div class="search-categories">
                            <form v-on:submit.prevent="searchProducts">
                                <div class="input-group">
                                    <input
                                    v-model="localSearchValue"
                                    class="form-control"
                                    type="text"
                                    placeholder="Zoek product...">
                                        <div class="input-group-append">
                                            <button
                                            class="btn btn-secondary"
                                            type="submit"
                                            @click="searchProducts()">
                                                <i class="fa fa-search" />
                                            </button>
                                        </div>
                                    <div
                                    v-if="localSearchValue.length >= 1"
                                    class="input-group-append">
                                        <button
                                        class="btn btn-danger"
                                        @click="clearLocalSearchValue()">
                                            <i class="fa fa-close" />
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- top-search-area end -->
                </div>
                <div class="col-lg-4 col-md-4">
                    <!-- header-cart-box start -->
                    <div class="header-cart-box">
                        <!-- setting-account start -->
                        <div
                        v-if="!isUserLoggedIn"
                        class="setting-account">
                            <div class="btn-group">
                                <button
                                class="btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                    Aanmelden
                                    <i class="fa fa-angle-down" />
                                </button>
                                <div class="dropdown-menu">
                                    <ul>
                                        <li>
                                          <router-link
                                          :to="{ name: 'login'}"
                                          class="nav-link">
                                            Inloggen
                                          </router-link>
                                        </li>
                                        <li>
                                          <router-link
                                          :to="{ name: 'register'}"
                                          class="nav-link">
                                          Registreren
                                          </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div
                        v-if="isUserLoggedIn"
                        class="setting-account">
                           <div class="btn-group">
                                <button
                                class="btn-link dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                    Mijn Account
                                    <i class="fa fa-angle-down" />
                                </button>
                                <div class="dropdown-menu">
                                    <ul>
                                        <li>
                                            <router-link
                                            :to="{ name: 'account'}"
                                            class="nav-link"
                                            >Mijn gegevens</router-link>
                                        </li>
                                        <li>
                                            <router-link
                                            :to="{ name: 'cart'}"
                                            class="nav-link">Winkelwagen
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link
                                            :to="{ name: 'logout'}"
                                            class="nav-link">
                                                Uitloggen
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- setting-account end -->
                        <!-- top-shopoing-cart start -->
                        <div
                        v-if="isUserLoggedIn"
                        id="top-shopoing-cart"
                        class="btn-group">
                            <button
                            class="btn-link shopping-cart dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                                <i class="fa fa-shopping-cart" />
                                <span class="top-cart-total">
                                    <span class="item-text-number">{{ cartSize }}</span>
                                    <span class="cart-text-items">Winkelwagen</span>
                                </span>
                            </button>
                            <cart-dropdown />
                        </div>
                        <!-- top-shopoing-cart end -->
                    </div>
                    <!-- header-cart-box end -->
                </div>
            </div>
        </div>
    </div>
    <!-- header-area end -->
    <!-- main-menu-area start -->
    <div class="main-menu-area bg-white mb-4">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <b-navbar toggleable="md" type="white" id="secondaryNavbar" variant="white" class="d-none d-md-block">
                        <b-navbar-toggle class="bg-secondary text-white" target="nav-collapse"><i class="fa fa-bars"></i></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav>
                            <b-navbar-nav class="text-center text-md-left">
                                <b-nav-item>
                                    <router-link to="/">Start</router-link>
                                </b-nav-item>
                                <b-nav-item>
                                    <router-link :to="{ name: 'products'}">Producten</router-link>
                                </b-nav-item>
                                <b-nav-item>
                                    <router-link :to="{ name: 'terms'}">Voorwaarden</router-link>
                                </b-nav-item>
                                <b-nav-item>
                                    <router-link :to="{ name: 'faq'}">Veel gestelde vragen</router-link>
                                </b-nav-item>
                                <hr>
                                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                                    <router-link
                                    :to="{ name: 'account'}"
                                    class="nav-link"
                                    >Mijn gegevens</router-link>
                                </li>
                                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                                    <router-link
                                    :to="{ name: 'cart'}"
                                    class="nav-link">Winkelwagen
                                    </router-link>
                                </li>
                                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                                    <router-link
                                    :to="{ name: 'logout'}"
                                    class="nav-link">
                                        Uitloggen
                                    </router-link>
                                </li>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </div>
                <div class="col-lg-4">
                    <div class="top-box-lang text-md-right text-center">
                        <ul>
                            <li
                            v-if="isUserLoggedIn"
                            class="warehouse">
                                <div class="btn-group">
                                    <button
                                    class="btn-link dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {{ warehouse.WarehouseID }}
                                        <i class="fa fa-angle-down" />
                                    </button>
                                    <div class="dropdown-menu" >
                                        <ul>
                                            <li
                                            v-for="warehouse in warehouses.Collection"
                                            :key="warehouse.WarehouseID">
                                                <a
                                                href="#"
                                                @click="setWarehouse(warehouse)">
                                                    {{ warehouse.WarehouseID }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <p>&nbsp;&nbsp;</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- main-menu-area end -->
  </header>
</template>

<script>
import WarehouseService from '@/services/WarehouseService.js'
import CartService from '@/services/CartService.js'
import TranslationService from '@/services/TranslationService'
import AuthorizationService from '@/services/AuthorizationService'
import CartDropdown from '@/components/Cart/CartDropdown'
import swal from 'sweetalert'

export default {
    components: {
        CartDropdown
    },
    data () {
        return {
            warehouses: {
                Collection: []
            },
            localSearchValue: '',
            isUserLoggedIn: false
        }
    },
    computed: {
        cartSize () {
            return this.$store.getters.cart.items.length
        },
        warehouse () {
            return this.$store.getters.warehouse
        },
        token () {
            return this.$store.getters.token
        }
    },
    mounted () {
        this.fetchWarehouses()
        this.isUserLoggedIn = AuthorizationService.isUserLoggedIn()
    },
    methods: {
        async fetchWarehouses () {
            this.warehouses = await WarehouseService.getWarehouses()
        },
        setWarehouse (warehouse) { // if we have items in cart, show a warning that cart will be emptied if user clicks OK
            if (this.$store.getters.cart.items.length > 0) {
                this.showChangeWarehousePopup(warehouse)
            } else {
                WarehouseService.setWarehouse(warehouse)
                this.$router.push({ name: 'products' })
            }
        },
        searchProducts () {
            this.$router.push({name: 'products', query: { q: this.localSearchValue }})
        },
        clearLocalSearchValue () {
            this.localSearchValue = ''
        },
        showChangeWarehousePopup (warehouse) {
            let _this_ = this
            let popup = {
                text: TranslationService.get('CANNOT_CHANGE_WAREHOUSE'),
                icon: 'warning',
                dangerMode: true,
                buttons: true
            }
            swal(popup).then(async function (changeWarehouse) {
                if (changeWarehouse) {
                    await CartService.clearCart()
                    WarehouseService.setWarehouse(warehouse)
                    _this_.$router.push({ name: 'products' })
                }
            })
        },
        getCartItems () {
            return this.$store.getters.cart
        }
    },
    watch: {
        '$store.getters.token': function (newVal, oldVal) {
            this.isUserLoggedIn = AuthorizationService.isUserLoggedIn()
            this.fetchWarehouses()
        }
    }
}
</script>
<style>
    #mobile-menu-active {
        padding-bottom: 20px;
        text-align: center;
    }
    #mobile-menu-active ul li a {
        font-size: 18px;
        padding-top:5px;
    }
    #secondaryNavbar {
        padding-left: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Template/Header.vue